export default __webpack_public_path__ + "static/media/1.cd77c0ec.jpg";